/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle, withState, withHandlers } from 'recompose'
import _get from 'lodash/get'
import { connect } from 'react-redux'
import { ALERTS } from 'constants/alerts'
import { analytics } from 'services/Analytics'
import { withLocalization } from 'hocs/localization'
import { getUserDetails, getUserSubscription, getUserFutureSubscription } from 'redux-app/selectors/user'
import { onVerifyCurrentCard } from 'redux-app/actionCreators/users'
import { createAlert, onShowError } from 'redux-app/modules/alerts'
import { onHideNewPlanAcceptedMessage } from 'redux-app/modules/user'
import { getCurrentSubscriptionPlan, getSubscriptionTerms, getSubscriptionRenewedTerms } from 'api/client/actions/subscriptions'
import ViewProfile from './ViewProfile'
import { ROUTES } from 'constants/routes'
import { EMPTY_OBJECT } from 'constants/frozenObjects'

export default compose(
  connect(
    (state, props) => {
      const userDetails = getUserDetails(state)
      const subscriptionDetails = getUserSubscription(state)
      const futureSubscription = getUserFutureSubscription(state)
      const futureContractType = futureSubscription !== EMPTY_OBJECT && futureSubscription !== null ? _get(futureSubscription, 'subscriptionContractType') : ''

      return {
        isBusiness: _get(userDetails, 'isBusinessAccount'),
        isRenewed: _get(subscriptionDetails, 'isSubscriptionRenewed'),
        hasPreviousContract: _get(subscriptionDetails, 'hasPreviousContract'),
        contractType: _get(subscriptionDetails, 'subscriptionContractType'),
        hasExtensionDocument: _get(subscriptionDetails, 'hasExtensionDocument'),
        futureContractType: futureContractType
      }
    },
    {
      getCurrentSubscriptionPlan,
      getSubscriptionTerms,
      getSubscriptionRenewedTerms,
      onHideNewPlanAcceptedMessage,
      onVerifyCurrentCard,
      createAlert,
      onShowError,
    },
  ),
  withLocalization('profile.view'),
  withState('currentPlan', 'setPlan', {}),
  withState('isLoading', 'setLoadingStatus', false),
  withHandlers({
    enrollPlanProcess: ({ history, onVerifyCurrentCard, onShowError }) => () => {
      onVerifyCurrentCard().then(({ value: { result } }) => {
        history.push(ROUTES.profile.enrollPlan.root)
        return
      })
      .catch(error => {
        onShowError(error)
      })
    },
    renewPlanProcess: ({ history, onVerifyCurrentCard, onShowError }) => () => {
      onVerifyCurrentCard().then(({ value: { result } }) => {
        history.push(ROUTES.profile.renewPlan.root)
        return
      })
      .catch(error => {
        onShowError(error)
      })
    },
  }),
  lifecycle({
    componentDidMount () {
      const { setLoadingStatus, getCurrentSubscriptionPlan, setPlan, onShowError } = this.props
      analytics.openMyProfilePage()
      setLoadingStatus(true)
      getCurrentSubscriptionPlan()
        .then(({ value: { result } }) => {
          setPlan(result)
          setLoadingStatus(false)
        })
        .catch(error => {
          onShowError(error)
          setLoadingStatus(false)
        })
    },
    componentWillUnmount () {
      this.props.onHideNewPlanAcceptedMessage()
    },
  }),
  withHandlers({
    downloadTerms: ({ onShowError, getSubscriptionTerms, createAlert }) => () => {
      getSubscriptionTerms()
        .then(({ value: { result } }) => {
          if (result.url) {
            window.open(result.url, '_blank')
          } else {
            createAlert({ name: ALERTS.noAgreement })
          }
        })
        .catch(error => {
          onShowError(error)
        })
    },
    downloadRenewedTerms: ({ onShowError, getSubscriptionRenewedTerms, createAlert }) => () => {
      getSubscriptionRenewedTerms()
        .then(({ value: { result } }) => {
          if (result.url) {
            window.open(result.url, '_blank')
          } else {
            createAlert({ name: ALERTS.noAgreement })
          }
        })
        .catch(error => {
          onShowError(error)
        })
    },
  }),
)(ViewProfile)
